/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconCurrencyTenge = createReactComponent("currency-tenge", "IconCurrencyTenge", [
  ["path", { d: "M6 5h12", key: "svg-0" }],
  ["path", { d: "M6 9h12", key: "svg-1" }],
  ["path", { d: "M12 9v10", key: "svg-2" }]
]);

export { IconCurrencyTenge as default };
//# sourceMappingURL=IconCurrencyTenge.js.map
